import { INTL_IDS } from './messages';

export const CHANGE_ADD_ESCROW_OPTION = 'app/Mortgage/CHANGE_ADD_ESCROW_OPTION';
export const CHANGE_STEP = 'app/Mortgage/CHANGE_STEP';

export const CHOOSE_DOCUMENT = 'app/Mortgage/CHOOSE_DOCUMENT';
export const CHOOSE_DOCUMENT_CANCELLATION = 'app/Mortgage/CHOOSE_DOCUMENT_CANCELLATION';
export const CHOOSE_DOCUMENT_FAILURE = 'app/Mortgage/CHOOSE_DOCUMENT_FAILURE';
export const CHOOSE_DOCUMENT_SUCCESS = 'app/Mortgage/CHOOSE_DOCUMENT_SUCCESS';

export const FETCH_HELOC_DRAW = 'app/Mortgage/FETCH_HELOC_DRAW';
export const FETCH_HELOC_DRAW_FAILURE = 'app/Mortgage/FETCH_HELOC_DRAW_FAILURE';
export const FETCH_HELOC_DRAW_SUCCESS = 'app/Mortgage/FETCH_HELOC_DRAW_SUCCESS';

export const FETCH_LOAN = 'app/Mortgage/FETCH_LOAN';
export const FETCH_LOAN_FAILURE = 'app/Mortgage/FETCH_LOAN_FAILURE';
export const FETCH_LOAN_SUCCESS = 'app/Mortgage/FETCH_LOAN_SUCCESS';

export const FETCH_MORTGAGE = 'app/Mortgage/FETCH_MORTGAGE';
export const FETCH_MORTGAGE_FAILURE = 'app/Mortgage/FETCH_MORTGAGE_FAILURE';
export const FETCH_MORTGAGE_SUCCESS = 'app/Mortgage/FETCH_MORTGAGE_SUCCESS';

export const FETCH_TRANSACTIONS = 'app/Mortgage/FETCH_TRANSACTIONS';
export const FETCH_TRANSACTIONS_FAILURE = 'app/Mortgage/FETCH_TRANSACTIONS_FAILURE';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/Mortgage/FETCH_TRANSACTIONS_SUCCESS';

export const FETCH_TRANSACTION_DETAIL = 'app/Mortgage/FETCH_TRANSACTION_DETAIL';
export const FETCH_TRANSACTION_DETAIL_FAILURE = 'app/Mortgage/FETCH_TRANSACTION_DETAIL_FAILURE';
export const FETCH_TRANSACTION_DETAIL_SUCCESS = 'app/Mortgage/FETCH_TRANSACTION_DETAIL_SUCCESS';

export const PROCESS_DOCUMENT = 'app/Mortgage/PROCESS_DOCUMENT';
export const PROCESS_DOCUMENT_FAILURE = 'app/Mortgage/PROCESS_DOCUMENT_FAILURE';
export const PROCESS_DOCUMENT_SUCCESS = 'app/Mortgage/PROCESS_DOCUMENT_SUCCESS';

export const RESET_ADD_ESCROW_OPTION = 'app/Mortgage/RESET_ADD_ESCROW_OPTION';
export const RESET_BANNER_ERROR = 'app/Mortgage/RESET_BANNER_ERROR';
export const RESET_CONFIRMATION = 'app/Mortgage/RESET_CONFIRMATION';
export const RESET_DOCUMENT_STATE = 'app/Mortgage/RESET_DOCUMENT_STATE';
export const RESET_ESCROW_HISTORY_STATE = 'app/Mortgage/RESET_ESCROW_HISTORY_STATE';
export const RESET_FORM_ERROR = 'app/Mortgage/RESET_FORM_ERROR';
export const RESET_FORM_ERRORS = 'app/Mortgage/RESET_FORM_ERRORS';
export const RESET_FORM_STATE = 'app/Mortgage/RESET_FORM_STATE';
export const RESET_HELOC_DRAW_FORM_FLOW_STATE = 'app/Mortgage/RESET_HELOC_DRAW_FORM_FLOW_STATE';
export const RESET_HELOC_DRAW_STATE = 'app/Mortgage/RESET_HELOC_DRAW_STATE';
export const RESET_REQUEST_STATUS_STATE = 'app/Mortgage/RESET_REQUEST_STATUS_STATE';
export const RESET_STEP_STATE = 'app/Mortgage/RESET_STEP_STATE';

export const SET_IS_HELOC_DRAW_AVAILABLE = 'app/Mortgage/SET_IS_HELOC_DRAW_AVAILABLE';

export const SET_SELECTED_MORTGAGE_LOAN = 'app/Mortgage/SET_SELECTED_MORTGAGE_LOAN';

export const SUBMIT_HELOC_DRAW = 'app/Mortgage/SUBMIT_HELOC_DRAW';
export const SUBMIT_HELOC_DRAW_FAILURE = 'app/Mortgage/SUBMIT_HELOC_DRAW_FAILURE';
export const SUBMIT_HELOC_DRAW_SUCCESS = 'app/Mortgage/SUBMIT_HELOC_DRAW_SUCCESS';

// eslint-disable-next-line max-len
export const SUBMIT_HELOC_DRAW_VALIDATION_FAILURE = 'app/Mortgage/SUBMIT_HELOC_DRAW_VALIDATION_FAILURE';

export const UPDATE_FORM_ERROR = 'app/Mortgage/UPDATE_FORM_ERROR';
export const UPDATE_FORM_VALUE = 'app/Mortgage/UPDATE_FORM_VALUE';
export const UPDATE_HELOC_DRAW_AMOUNT = 'app/Mortgage/UPDATE_HELOC_DRAW_AMOUNT';
export const UPDATE_SELECTED_INSURANCE = 'app/Mortgage/UPDATE_SELECTED_INSURANCE';
export const UPDATE_SELECTED_TRANSACTION = 'app/Mortgage/UPDATE_SELECTED_TRANSACTION';

export const UPLOAD_DOCUMENT = 'app/Mortgage/UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_FAILURE = 'app/Mortgage/UPLOAD_DOCUMENT_FAILURE';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/Mortgage/UPLOAD_DOCUMENT_SUCCESS';

export const VALIDATE_ROUTING = 'app/Mortgage/VALIDATE_ROUTING';
export const VALIDATE_ROUTING_FAILURE = 'app/Mortgage/VALIDATE_ROUTING_FAILURE';
export const VALIDATE_ROUTING_SUCCESS = 'app/Mortgage/VALIDATE_ROUTING_SUCCESS';

/* eslint-disable max-len */
export const FETCH_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your documents. If this issue persists, please call customer service.';
export const FETCH_TRANSACTION_DETAIL_ERROR_MESSAGE = 'Document unavailable at the moment. Please contact Customer Service if this persists.';
export const NO_TRANSACTIONS_MESSAGE = 'No payment history. Please check again after a payment has been made.';

export const EXPIRED_POLICY_BANNER_MESSAGE = '{{policy}} on file has expired.\n Please update it to avoid lapse in coverage.';

export const CONSTRUCTION_LOAN_DISCLAIMER_DICT = {
  text: 'The available Undisbursed Construction Funds disclosed is as of the previous business day and this amount does not include any transactions that have not posted as of this date, any preauthorized transactions and any check or other payment made on the account that is returned unpaid or is rejected for any reason. You are responsible for ensuring you do not attempt to obtain Construction Funds that would exceed your Construction Line Amount.',
  variant: 'warning',
};
export const HELOC_DISCLAIMER_DICT = {
  text: 'The available Credit Line Remaining disclosed is as of the previous business day and this amount does not include any transactions that have not posted as of this date, any preauthorized transactions, and any check or other payment made on the account that is returned unpaid or is rejected for any reason. You are responsible for ensuring you do not attempt to obtain advances that would exceed your Credit Limit.',
  variant: 'warning',
};

/*
  insurance types returned from the API as of 8/20/21 (per Krishna):
    - Homeowners (Primary)
    - Flood
    - Windstorm
    - Earthquake
    - Miscellaneous
    - Other
*/
export const INSURANCE_TYPE_DICT = {
  Earthquake: 'Earthquake Insurance',
  Flood: 'Flood Insurance',
  'Homeowners (primary)': 'Homeowners Insurance (Primary)',
  Miscellaneous: 'Miscellaneous Insurance',
  Other: 'Other',
  Windstorm: 'Windstorm Insurance',
};

export const MORTGAGE_DETAILS_DICTIONARY = {
  currentPrincipalBalance: INTL_IDS.MORTGAGE_DETAILS_LABEL_PRINCIPALBALANCE,
  effectiveInterestRate: INTL_IDS.MORTGAGE_DETAILS_LABEL_CURRENTINTERESTRATE,
  loanMaturityDate: INTL_IDS.MORTGAGE_DETAILS_LABEL_MATURITYDATE,
  loanOriginationDate: INTL_IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANDATE,
  loanType: INTL_IDS.MORTGAGE_DETAILS_LABEL_LOANTYPE,
  originalMortgageAmount: INTL_IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANAMOUNT,
};

export const EXPIRED_POLICY_DICT = {
  Earthquake: 'earthquake policy',
  Flood: 'flood policy',
  'Homeowners (primary)': 'homeowners policy',
  Miscellaneous: 'miscellaneous policy',
  Other: 'miscellaneous policy',
  Windstorm: 'windstorm policy',
};

export const INSURANCE_UPLOAD_DICT = {
  confirmation: {
    errorText: 'We are unable to upload your documents at this time',
    header: 'Insurance Confirmation',
    pendingText: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
    subHeader: 'Success! We received your request',
    text: 'Your document was submitted and has been referred to the appropriate area for review.',
  },
  uploadReviewHeaderSubText: 'Your document will be reviewed once it is submitted. ',
};

export const ADD_ESCROW_DICT = {
  confirmationView: {
    autoPayCard: {
      cardHeader: 'Never miss a payment',
      cardText: 'Set up automatic payments. It\'s simple, convenient, and efficient.',
      iconName: 'autopayMoney',
    },
    errorText: 'We are unable to upload your documents at this time',
    header: 'Escrow Confirmation',
    infoText: 'If everything is in order you\'ll receive a cover letter and pre-paid envelope containing your escrow projection, initial deposit amount, monthly escrow payment amount, and instructions for moving forward.',
    pendingText: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
    subheader: 'Success! We received your request\nto set up escrow',
    text: 'Your request has been received and is being processed. You will get an email notification once your request is completed. This usually takes a few business days.',
  },
  docReview: {
    multiDocReviewDict: [
      {
        header: 'Review before you continue',
        text: 'If your property tax document looks good, go to the next step to upload your Homeowner Declaration.',
      },
      {
        header: 'Review your documents',
        text: 'Your documents will be reviewed once they are submitted.',
      },
    ],
    singleDocReviewDict: [
      {
        header: 'Review your document',
        text: 'Your document will be reviewed once it is submitted.',
      },
    ],
  },
  docUpload: {
    Both: {
      description: 'Make sure your document is readable, complete, and includes any signatures if applicable.',
      secondaryHeader: ['Upload property tax bill', 'Upload Homeowners Insurance Declarations Page'],
    },
    header: 'Upload Document',
    'Homeowners Insurance': {
      description: 'Make sure your document is readable, complete, and includes any signatures if applicable.',
      secondaryHeader: ['Upload Homeowners Declaration'],
    },
    'Property Tax': {
      description: 'Make sure your document is readable, complete, and includes any signatures if applicable.',
      secondaryHeader: ['Upload property tax bill'],
    },
  },
  escrowResources: {
    definition: {
      header: 'What is an escrow account?',
      text: INTL_IDS.MORTGAGE_ESCROW_SPLASH_DEFINITION_CARD_TEXT,
    },
    header: 'Escrow Resources',
    links: [
      {
        label: 'What is an escrow account?',
        path: 'Glossary',
      },
      {
        label: 'Frequently asked questions',
        path: 'Faq',
      },
      {
        label: 'Educational Videos',
        path: 'LearningCenter',
      },
    ],
  },
  mortgageCards: [
    {
      header: 'Open an escrow account',
      iconName: 'PiggyBig',
      path: 'AddEscrow',
      text: 'Payments are made on your behalf so you don\'t have to keep track of deadlines.',
    },
    {
      header: 'See future payments',
      iconName: 'calendarLarge',
      mainPath: 'Calculators',
      path: 'Amortize',
      text: 'View the breakdown of principal & interest you will pay over time.',
    },
  ],
  setUpOptions: {
    buttonText: 'Next',
    header: 'Set Up Escrow',
    notification: 'Your property tax payments must be up-to-date, and your insurance policy must be active and paid.',
    options: [
      {
        description: 'Upload your most recent property tax bill.',
        optionHeader: 'Property Tax',
      },
      {
        description: 'Upload your homeowners insurance declarations page.',
        optionHeader: 'Homeowners Insurance',
      },
      {
        description: 'Upload your most recent property tax bill and homeowner\'s insurance declaration page.',
        optionHeader: 'Both',
      },
    ],
    secondaryHeader: 'What type of escrow account \n do you want to set up?',
  },
  splashScreen: {
    body: {
      paragraph1: {
        secondaryHeader: 'Budgeting made easy',
        text: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_1,
      },
      paragraph2: {
        secondaryHeader: 'All-in-one convenience',
        text: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_2,
      },
      paragraph3: {
        secondaryHeader: 'Automatic, on-time payments',
        text: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_3,
      },
    },
    buttonText: 'Set Up Escrow',
    header: 'Top benefits of an escrow account',
  },
  uploadConfirmation: {
    description: 'Your request has been received and is being processed. You will get an email notification once your request is completed. This usually takes a few business days.',
    header: 'Confirmation',
    infoMessage: {
      info1: {
        icon: 'pending',
        message: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
      info2: {
        icon: 'info',
        message: 'If everything is in order you\'ll receive a cover letter and pre-paid envelope containing your escrow projection, initial deposit amount, monthly escrow payment amount, and instructions for moving forward.',
      },
    },
    secondaryHeader: 'Success! We received your request to set up escrow',
  },
};

export const ESCROW_ADD_DICTIONARY = {
  confirmation: {
    infoMessages: [
      {
        icon: 'pending',
        message: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
      {
        icon: 'info',
        message: 'If everything is in order you\'ll receive a cover letter and pre-paid envelope containing your escrow projection, initial deposit amount, monthly escrow payment amount, and instructions for moving forward.',
      },
    ],
    subHeader: 'Success! We received your request to set up escrow',
    text: 'Your request has been received and is being processed. You will get an email notification once your request is completed. This usually takes a few business days.',
  },
  setUp: {
    alertBanner: 'Your property tax payments must be up-to-date, and your insurance policy must be active and paid.',
    subHeader: 'What type of escrow account do you want to set up?',
  },
};

/* eslint-disable max-len */
export const ESCROW_BENEFITS_LIST = [
  {
    header: 'Budgeting made easy',
    paragraph: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_1,
  },
  {
    header: 'All-in-one convenience',
    paragraph: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_2,
  },
  {
    header: 'Automatic, on-time payments',
    paragraph: INTL_IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_3,
  },
];

export const ESCROW_TYPES_LIST = [
  {
    header: 'Property Tax',
    paragraph: 'Upload your most recent property tax bill.',
    type: 'propertyTax',
  },
  {
    header: 'Homeowners Insurance',
    paragraph: 'Upload your homeowners insurance declarations page.',
    type: 'homeownersInsurance',
  },
  {
    header: 'Both',
    paragraph: 'Upload your most recent property tax bill and homeowner\'s insurance declaration page.',
    type: 'both',
  },
];

export const ESCROW_TYPE_UPLOADS = {
  both: [
    {
      documentName: 'Property Tax Bill',
      fieldName: 'fileInput',
    },
    {
      documentName: 'Homeowners Declaration',
      fieldName: 'secondFileInput',
    },
  ],
  homeownersInsurance: [
    {
      documentName: 'Homeowners Declaration',
      fieldName: 'fileInput',
    },
  ],
  propertyTax: [
    {
      documentName: 'Property Tax Bill',
      fieldName: 'fileInput',
    },
  ],
};

export const HELOC_DRAW_PROPS_DICTIONARY = {
  confirmation: {
    header: 'HELOC Draw Confirmation',
    linkLabel: 'Return to Mortgage',
    subHeader: 'Your request has been received and will be processed. An email will be sent to you confirming that we have received your request.',
    successHeader: 'Success! We received your\nrequest for a HELOC draw',
  },
  details: {
    creditLineLimit: 'Credit Line Limit', // eslint-disable-next-line sort-keys
    availableAdvanceAmount: 'Available Advance Amount',
    minimumAdvanceAmount: 'Minimum Advance Amount',
  },
  error: {
    label: 'Return to Mortgage',
    mobilePath: 'Mortgage',
    pageHeading: 'HELOC Draw Error',
    subHeading: 'Sorry! Something went wrong',
    textString: 'We apologize for the inconvenience. Please try again later.',
  },
  form: {
    accountInformation: {
      disclaimers: [
        'By entering in the information for the bank account below and clicking "Review Request", you affirm that you are the authorized bank account holder of the account.',
        'Please note that if you provide valid bank account information, then any funds disbursement cannot be reversed.',
      ],
      header: 'Bank Account Information',
      // generic subheader for Heloc Draw forms
      subheader: 'Please enter the Depository Account for {{clientName}}.',
      subheaderForRoutingNumberVariant: 'Please enter the Depository Account information.',
    },
    availableCreditDisclaimer: 'The Available Credit figures disclosed are as of the previous business day and this amount does not include any HELOC Advance transactions that have not posted as of this date, any preauthorized transactions, any previous same day HELOC Advance requests not submitted through this website, and any check or other payment made on the account that is returned unpaid or is rejected for any reason.',
    bannerText: {
      alreadyRequested: '<b>Thank you for submitting a HELOC Request</b>. Please note that a new request cannot be made until the first request has been processed.',
      ineligible: '<b>You are ineligible to request a HELOC draw.</b> Please contact customer service at {{customerServicePhoneNumber}} for assistance.',
    },
    buttonLabel: 'Review Request',
    disclaimer: {
      // generic advanceAmount disclaimer for clients without bank account info
      advanceAmountDisclaimer: 'Deposit of funds may take 24-48 hours to process.',
      cutoffDisclaimer: 'Cut-off time for HELOC advance requests for same day processing is 12:00pm/noon CST. Requests after 12:00pm CST will be processed the next business day. Interest will begin to accrue on the date the advance is posted to your Credit Line. Your advance funds may take up to 2-3 days to be credited to your deposit account.',
    },
    formHeader: 'Request funds from your HELOC',
    inputLabel: 'Advance Amount',
    screenHeader: 'HELOC Draw',
  },
  mortgageHomeCard: {
    cardHeader: 'Request HELOC Draw',
    cardText: 'Access funds from your home equity line of credit.',
    iconName: 'detailedKey',
    path: 'HelocDrawPreConfirmation',
  },
  review: {
    buttonLabel: 'Submit',
    cardHeader: 'Almost done. Review the details of your HELOC draw request',
    cardSubheader: 'Please review this page carefully before proceeding to ensure all details are accurate. Once you click “Submit", this request cannot be changed or cancelled.',
    disclaimer: 'There is no fee to use this service.',
    header: 'Review HELOC Draw',
    helocDrawCheckboxLabel: 'I acknowledge that I have read and understood the above. ',
  },
};

export const HELOC_DRAW_INELIGIBLE = 'ineligible';
export const HELOC_DRAW_INELIGIBLE_STATUS = 'Not_Available';

export const HELOC_DRAW_PENDING = 'pending';
export const HELOC_DRAW_PENDING_STATUS = 'Pending_Draw';

export const HELOC_DRAW_PARTIAL_CREATE_ERRORS = [
  '102000.1007',
  '102000.1008',
  '102000.1009',
  '102000.2002',
  '102000.2003',
  '102000.2004',
  '102000.2005',
];

export const HELOC_DRAW_API_REASON_CODE_DICTIONARY = {
  102000.1007: {
    field: 'amount',
    message: 'Advance Amount has to be greater than zero',
  },
  102000.1008: {
    field: 'amount',
    message: 'Advance Amount has to be less than the available advance amount',
  },
  102000.1009: {
    field: 'amount',
    message: 'Advance Amount is less than minimum draw amount',
  },
  102000.2002: {
    field: 'accountNumber',
    message: 'Account Number is required',
  },
  102000.2003: {
    field: 'accountNumber',
    message: 'Account Number is invalid',
  },
  102000.2004: {
    field: 'nameOnAccount',
    message: 'Name on Account is required',
  },
  102000.2005: {
    field: 'nameOnAccount',
    message: 'Name on Account is invalid',
  },
};
